/* eslint-disable */
import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-added-trip-type',
  templateUrl: './added-trip-type.page.html',
  styleUrls: ['./added-trip-type.page.scss']
})
export class AddedTripTypePage implements OnInit {

  tripType = '';
  survey: any;
  valid = false;

  constructor(
    private navParams: NavParams,
    private popoverCtrl: PopoverController,
  ) {}

  setType(value: string) {
    this.tripType = value;
  }

  validate(value: string) {
    if (value) {
      this.survey.addedTripType = value;
      this.valid = true;
    }
  }

  next() {
    this.dismiss(this.survey);
  }

  dismiss(data = null) {
    this.popoverCtrl.dismiss(data);
  }

  init() {
    this.survey = this.navParams.data.survey;
  }

  ionViewWillEnter() {
    this.init();
  }

  ngOnInit() {}
}
